import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationSource} from "../../utils/form/application_form_source";
import {getAmplitudeLeadFormInquiryTopicsSelectedFromSubmit, ILeadSubmitInquirySelection} from "./get_amplitude_lead_form_inquiry_topics_selected";
import {getAmplitudeLeadFormStartEventProperties, IGetAmplitudeLeadFormStartEventPropertiesParams} from "./get_amplitude_lead_form_start_event_properties";

type LeadResponseProperties =
    | {
          leadResponse: IApplicationData;
          marketingApproval?: never;
          transactionId?: never;
      }
    | {
          /** Each product carries its own transaction_id for events covering several created leads at once. */
          leadResponse?: never;
          marketingApproval: boolean;
          transactionId?: never;
      }
    | {
          /** A single application created by the backend (not posted by the lead form) - only its uuid is known. */
          leadResponse?: never;
          marketingApproval: boolean;
          transactionId: string;
      };

// DS-A-44
export type IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams = IGetAmplitudeLeadFormStartEventPropertiesParams &
    LeadResponseProperties & {
        inquirySelection: ILeadSubmitInquirySelection;
        ctaText?: string;
    };

export const getAmplitudeLeadFormGenerateLeadEventProperties = (params: IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams) => {
    const {leadResponse, marketingApproval, transactionId, inquirySelection, trackingContext, leadData, source, sourceSection, eventAction, ctaText} = params;

    const base = getAmplitudeLeadFormStartEventProperties({
        trackingContext,
        leadData,
        source,
        sourceSection,
        eventAction
    });

    const inquiryTopics = source === ApplicationSource.NegotiatePrice ? [] : base.inquiry_topics;
    const inquiryTopicsSelected = getAmplitudeLeadFormInquiryTopicsSelectedFromSubmit(source, inquirySelection);

    const resolvedMarketingApproval = marketingApproval ?? Boolean(leadResponse?.marketing_email || leadResponse?.marketing_sms);

    return {
        ...base,
        ...(ctaText ? {cta_text: ctaText} : {}),
        ...(leadResponse ? {transaction_id: leadResponse.uuid} : {}),
        ...(transactionId ? {transaction_id: transactionId} : {}),
        ...(trackingContext.rp_search_stage != null && {rp_search_stage: trackingContext.rp_search_stage}),
        inquiry_topics: inquiryTopics,
        inquiry_topics_selected: inquiryTopicsSelected,
        marketing_approval: resolvedMarketingApproval
    };
};
import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationSource} from "../../utils/form/application_form_source";
import {getAmplitudeLeadFormInquiryTopicsSelectedFromSubmit, ILeadSubmitInquirySelection} from "./get_amplitude_lead_form_inquiry_topics_selected";
import {getAmplitudeLeadFormStartEventProperties, IGetAmplitudeLeadFormStartEventPropertiesParams} from "./get_amplitude_lead_form_start_event_properties";

type LeadResponseProperties =
    | {
          leadResponse: IApplicationData;
          marketingApproval?: never;
          transactionId?: never;
      }
    | {
          /** Each product carries its own transaction_id for events covering several created leads at once. */
          leadResponse?: never;
          marketingApproval: boolean;
          transactionId?: never;
      }
    | {
          /** A single application created by the backend (not posted by the lead form) - only its uuid is known. */
          leadResponse?: never;
          marketingApproval: boolean;
          transactionId: string;
      };

// DS-A-44
export type IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams = IGetAmplitudeLeadFormStartEventPropertiesParams &
    LeadResponseProperties & {
        inquirySelection: ILeadSubmitInquirySelection;
        ctaText?: string;
    };

export const getAmplitudeLeadFormGenerateLeadEventProperties = (params: IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams) => {
    const {leadResponse, marketingApproval, transactionId, inquirySelection, trackingContext, leadData, source, sourceSection, eventAction, ctaText} = params;

    const base = getAmplitudeLeadFormStartEventProperties({
        trackingContext,
        leadData,
        source,
        sourceSection,
        eventAction
    });

    const inquiryTopics = source === ApplicationSource.NegotiatePrice ? [] : base.inquiry_topics;
    const inquiryTopicsSelected = getAmplitudeLeadFormInquiryTopicsSelectedFromSubmit(source, inquirySelection);

    const resolvedMarketingApproval = marketingApproval ?? Boolean(leadResponse?.marketing_email || leadResponse?.marketing_sms);

    return {
        ...base,
        ...(ctaText ? {cta_text: ctaText} : {}),
        ...(leadResponse ? {transaction_id: leadResponse.uuid} : {}),
        ...(transactionId ? {transaction_id: transactionId} : {}),
        ...(trackingContext.rp_search_stage != null && {rp_search_stage: trackingContext.rp_search_stage}),
        inquiry_topics: inquiryTopics,
        inquiry_topics_selected: inquiryTopicsSelected,
        marketing_approval: resolvedMarketingApproval
    };
};
